<template>
  <div>
      <section> <router-view/> </section>
  </div>
</template>

<script>
export default {
    components: {

    },
    data(){
        return {

        }
    },
    created(){

    },
    methods: {

    }
}
</script>

<style lang="scss">

</style>